<template>
  <div class="review-box-inner">
    <div>
      <div class="review-cover">
        <router-link :to="{name: 'BooksDetails', params: {id: props.book_id}}">
          <a href="#" class="">
            <img :src="(coverUrl + props.image)" :alt="props.tytul" />
          </a>
        </router-link>
      </div>
      <div class="review-content" :class='{expanded: isReadMore}'>
        <div class="review-title">
        <router-link :to="{name: 'Authors', params: {id: props.author_id}}">
          <span class="author-link">{{props.autor}}</span>
        </router-link>
          <br>
          <!-- <div class="mt-1 mb-1">{{props.autor}}</div> -->
        </div>
        <div class="review-title">
        <router-link :to="{name: 'BooksDetails', params: {id: props.book_id}}">
          <span class="title-link">{{props.tytul}}</span>
        </router-link>
          <br>
          <!-- <div class="mt-1 mb-1">{{props.autor}}</div> -->
        </div>
        <p>
          {{props.content.slice(0, 150)}}...
        </p>
      </div>
      <div class="d-flex justify-content-between">
        <button class="btn-black-border w-100 mt-3 mb-1 col-5" @click="routeEdit">edytuj</button>
        <button class="btn-black-border w-100 mt-3 mb-1 col-5" @click="routerMore">zobacz</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ReviewElement',
  props: {
    props: Object
  },
  data () {
    return {
      isReadMore: false
    }
  },
  methods: {
    routerMore () {
      this.$router.push({ name: 'ReviewDetails', params: { id: this.props.id, book_id: this.props.book_id } })
    },
    routeEdit () {
      this.$router.push({ name: 'ReviewEdit', params: { id: this.props.id, book_id: this.props.book_id } })
    }
  }
}
</script>
<style lang="scss" scoped>
  .review-content {
    p {
      color: #000;
    }
  }
  .author-link {
    font-size: 11px;
    color: #222;
  }
</style>
